<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import EditButtonView from "../../../../component/common/Button/EditButtonView.svelte";
    import PlatformTypeIconView from "../../../../component/Binary/PlatformTypeIconView.svelte";
    import {UrlUtil} from "../../../../lib/Common/Http/UrlUtil";
    import {MessageStore} from "../../../../store/MessageStore";
    import {HttpRequestUtil} from "../../../../lib/Common/Http/HttpRequestUtil";
    import LabelValueView from "../../../../component/common/Value/LabelValueView.svelte";
    import {SizeUtil} from "../../../../lib/Common/Value/SizeUtil";
    import BinaryTagAreaView from "./Tag/BinaryTagAreaView.svelte";
    import CreatedUpdatedView from "../../../../component/common/Value/CreatedUpdatedView.svelte";
    import BinaryDescriptionView from "./Parts/BinaryDescriptionView.svelte";
    import BinaryQrCodeView from "./Parts/BinaryQrCodeView.svelte";
    import FontAwesomeView from "../../../../component/common/Image/FontAwesomeView.svelte";
    import BinaryDownloadView from "../../../../component/Binary/BinaryDownloadView.svelte";
    import BinaryLinkCopyButtonView from "./Parts/BinaryLinkCopyButtonView.svelte";
    import BinaryStatusAreaView from "../../../../component/Binary/BinaryStatusAreaView.svelte";
    import BinaryCiJobLinkView from "./Parts/BinaryCiJobLinkView.svelte";
    import BinaryStatusNoticeView from "./Parts/BinaryStatusNoticeView.svelte";
    import BinaryIconView from "./Parts/BinaryIconView.svelte";
    import {QrCodeDialogStore} from "../../../../store/dialog/QrCodeDialogStore";
    import BinaryDeleteProtectView from "./Parts/BinaryDeleteProtectView.svelte";
    import IntersectionObserverView from "../../../../component/common/Loading/IntersectionObserverView.svelte";


    const dispatcher = createEventDispatcher();

    export let space;
    export let app;
    export let binary;

    $: binaryUrl = (() => {
        if (space == null) {
            return '';
        }
        if (binary == null) {
            return '';
        }
        const binaryUrl = `/#/space/${space.unique_id}/app/${app.unique_id}/binary/${binary.unique_id}`;
        return binaryUrl;
    })();


    $: jumpUrl = (() => {
        if (binary == null) {
            return null;
        }
        const jumpUrl = `/#/space/${space.unique_id}/app/${app.unique_id}/binary/${binary.unique_id}`;
        return jumpUrl;
    })();

    let isLoading = false;

    onMount(() => {
    });

    function onClickEdit() {
        dispatcher('edit', {binary: binary});
    }

    function onClickRefreshSecretKey() {
        const message = `QRコードをリフレッシュしますか？`;
        MessageStore.showConfirmInformationYesNo(message, () => {
            const url = UrlUtil.createApiUrl("binary/refresh_download_key");

            const paramMap = {};
            paramMap['id'] = binary.id;

            isLoading = true;
            HttpRequestUtil.postRequest(url, paramMap, (response) => {
                isLoading = false;
                console.log(response);
                const body = response['body'];


                dispatcher('update');

            });

        });

    }


    function onClickVersionQrCode() {
        const version = binary.version;
        const showData = new QrCodeDialogStore.ShowData();
        showData.qrCodeValue = version;
        showData.title = `バージョン: ${version} のコピペ用`;
        showData.size = 300;
        QrCodeDialogStore.showData.set(showData);

    }

</script>

<tr class="binary-row-view">
    <td class="edit-platform-icon-cell">
        <div class="edit-platform-icon-content">
            <div class="edit-platform-area">
                <div>
                    <EditButtonView on:click={onClickEdit}/>
                </div>
                <div class="platform-icon">
                    <PlatformTypeIconView platformType={binary.platform_type}/>
                </div>

            </div>
            <div class="icon-area">
                <IntersectionObserverView>
                    <BinaryIconView binary={binary} jumpUrl={jumpUrl}/>
                </IntersectionObserverView>
            </div>
        </div>

        <div class="command-icon-area">
            <BinaryDeleteProtectView binary={binary} on:update/>
        </div>

        <div class="created-updated-area">
            <CreatedUpdatedView model={binary} isShowUser={false}/>
        </div>
    </td>

    <td class="name-tag-description-cell">
        <div class="status-notice-area">
            <BinaryStatusNoticeView binary={binary}/>
        </div>
        <div class="name-area">
            <div class="name">
                <a href={jumpUrl}>
                    { binary.name }
                </a>
            </div>


            <div class="copy-button">
                <BinaryLinkCopyButtonView
                        spaceUniqueId={space.unique_id}
                        appUniqueId={app.unique_id} binary={binary}
                />
            </div>

        </div>
        <div class="tag-area">
            <BinaryTagAreaView spaceUniqueId={space.unique_id} appUniqueId={app.unique_id} binary={binary}
                               canEdit={true}
                               canJumpUrl={true}
                               on:openAddBinaryTag on:update
            />
        </div>

        <div class="download-area">
            <fieldset>
                <legend>ファイルとしてダウンロード</legend>
                <BinaryDownloadView binary={binary}/>
            </fieldset>
        </div>

        <div class="ci-job-link-area">
            <BinaryCiJobLinkView binary={binary}/>
        </div>

    </td>

    <td class="qr-code">
        <BinaryQrCodeView binary={binary} on:update/>
    </td>

    <td class="description">
        <div class="description-area">
            <BinaryDescriptionView binary={binary} maxHeightEm={10}/>
        </div>
        <div class="detail-link">
            <a href={jumpUrl}>
                <FontAwesomeView icon="chevron-right"/>
                詳細を見る
            </a>
        </div>
    </td>
    <td class="information-cell">
        <div class="information-content">
            <div class="information-area">
                <div>
                    <BinaryStatusAreaView binary={binary}/>
                </div>


                <div>
                    <LabelValueView label="ユニークID" value={binary.unique_id}/>
                    <LabelValueView label="version" value={binary.version}/>
                    {#if binary.version != null}
                        <span class="version-qr-code-button" on:click={onClickVersionQrCode}>
                            <FontAwesomeView icon="qrcode"/>
                        </span>
                    {/if}
                    <LabelValueView label="m5 hash" value={binary.md5_hash}/>
                    <LabelValueView label="ファイルサイズ"
                                    value={SizeUtil.formatBytes(binary.file_size) }/>
                    <LabelValueView label="ファイル名" value={binary.file_name}/>
                    <LabelValueView label="DL回数" value={binary.download_count}/>
                    <LabelValueView label="最終DL日時" value={binary.latest_download_at}/>

                </div>


            </div>


        </div>
    </td>


</tr>
<style lang="scss">
    .binary-row-view {
        td {
            &.edit-platform-icon-cell {
                .edit-platform-icon-content {
                    display: flex;
                    gap: 12px;

                    .edit-platform-area {
                        text-align: center;

                        .platform-icon {
                            margin-top: 12px;
                            font-size: 30px;
                        }

                    }

                    .icon-area {
                        width: 80px;
                        height: 80px;
                    }

                }

                .created-updated-area {
                    margin-top: 4px;
                    opacity: 0.75;
                    font-size: 0.75em;

                }
            }


            &.name-tag-description-cell {
                .name-area {
                    transition-duration: 0.25s;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    flex-wrap: wrap;

                    .name {
                        > a {
                            word-break: break-word;
                        }

                    }

                    .copy-button {

                    }


                }

                .tag-area {
                    margin-top: 12px;
                    font-size: 0.9em;
                }


                .download-area {
                    margin-top: 12px;
                    font-size: 0.9em;
                }

                .ci-job-link-area {
                    margin-top: 12px;
                }

            }


            &.qr-code {
                .qr-code-area {
                    position: relative;
                    min-height: 3em;
                    min-width: 8em;

                    .no-secret-key {
                        font-size: 0.5em;
                        opacity: 0.5;
                    }

                    .refresh-button-area {
                        opacity: 0;
                        position: absolute;
                        bottom: 0;
                        right: 0;

                        font-size: 0.5em;

                        .refresh-button {
                            cursor: pointer;

                        }
                    }

                    .open-button-area {
                        opacity: 0;
                        position: absolute;
                        bottom: 0;
                        left: 0;

                        font-size: 0.5em;

                        .open-button {
                            cursor: pointer;

                        }
                    }

                    &:hover {
                        .refresh-button-area {
                            opacity: 1;
                        }

                        .open-button-area {
                            opacity: 1;
                        }
                    }

                }

            }

            &.description {
                .description-area {
                    max-width: 600px;
                }

                .detail-link {
                    font-size: 0.75em;
                    text-align: right;
                }
            }

            &.information-cell {
                width: 360px;
                height: 100%;

                .information-content {
                    display: flex;
                    flex-direction: column;
                    height: 100%;

                    .information-area {
                        flex-grow: 1;

                        display: flex;
                        flex-direction: column;
                        gap: 8px;

                        .version-qr-code-button {
                            cursor: pointer;
                        }
                    }

                    .date-area {
                        margin-top: 60px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                    }

                }
            }
        }


    }
</style>